import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  ActivatedRoute,
  NavigationExtras,
} from "@angular/router";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { Location } from "@angular/common";
// import { StorePermissionsService } from "../services/master/store-permissions.service";
// import { ApiService } from "src/app/services/api";

@Injectable({
  providedIn: "root",
})
export class AccessGuard implements CanActivate {
  authorized: boolean;
  permissions: any = [];
  userData;
  // storePermissions;
  userStorePermissions;
  permissionName;
  access;
  constructor(
    private store: Store<any>,
    public router: Router,
    private cookieService: CookieService,
    private location: Location,
    // private storePermissionService: StorePermissionsService,
    // private apiService:ApiService
  ) {
    this.userData = JSON.parse(localStorage.getItem("userData"));
    // this.storePermissions = JSON.parse(localStorage.getItem("storePermissions"));

    if (this.userData) {
      this.permissions = this.userData?.response?.role?.permissions;
    } else {
      this.permissions = []
    }
    // this.storePermissionService.GLOBALURL = this.apiService.getBaseURL()

    // console.log("this.storePermissions", this.storePermissions);
    console.log("this.permissions", this.permissions);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const storeId = this.cookieService.get("storeId") || "";
    const userDataObj = this.userData?.response;

    const isOwner = userDataObj?.isOwner;
    if (isOwner) {
      return true;
    }

    // if (userDataObj.storeId != selectedStoreId) {

    //   this.router.navigate(["/403"],{
    //     queryParams: { returnUrl: this.router.url },
    //   });
    //   return false;
    // }

    this.permissionName = next.data["permissionName"];
    this.access = +next.data["access"];

    if(storeId && storeId === "*"){}
    else
    {

      // @ STORE PERMISSIONS
      // const storePermission = this.storePermissions.find(store => store.storeId === storeId);
      // if(storePermission){
      //   const module = storePermission.permissions.find(item => item.permissionName === this.permissionName);
      //   if (module && +module.permissionValue >= this.access) {
      //     return true;
      //   }
      //   this.router.navigate(["/403"], {
      //     queryParams: { returnUrl: this.router.url },
      //   });
      //   return false;
      // }

      // @ USER STORE PERMISSIONS
      this.userStorePermissions = JSON.parse(localStorage.getItem("userStorePermissions"));
      const userStorePermission = this.userStorePermissions
      if(userStorePermission?.length){
        const module = userStorePermission.find(item => item.permissionName === this.permissionName);
        if (module && +module.permissionValue >= this.access) {
          return true;
        }
        this.router.navigate(["/403"], {
          queryParams: { returnUrl: this.router.url },
        });
        return false;
      }
      else{

        if (this.permissions == null) {
          this.router.navigate(["/403"]);
        }

        if (this.permissionName == "home") {
          return true;
        }

        const module: any = this.permissions.find(
          (access) => access.permissionName === this.permissionName
        );

        let variable;
        if (module) {
          variable =
            Number(module["permissionValue"]) >= Number(this.access) ? true : false;
          if (!variable) {
            this.router.navigate(["/403"], {
              queryParams: { returnUrl: this.router.url  },
            });
          } else {
            return true;
          }
        }

        this.router.navigate(["/403"], {
          queryParams: { returnUrl: this.router.url  },
        });
        return false;
      }
    }

    // if (this.permissions == null) {
    //   this.router.navigate(["/403"]);
    // }

    // if (this.permissionName == "home") {
    //   return true;
    // }

    // const module: any = this.permissions.find(
    //   (access) => access.permissionName === this.permissionName
    // );
    // let variable;
    // if (module) {
    //   variable =
    //     Number(module["permissionValue"]) >= Number(this.access) ? true : false;
    //   if (!variable) {
    //     this.router.navigate(["/403"], {
    //       queryParams: { returnUrl: this.router.url  },
    //     });
    //   } else {
    //     return true;
    //   }
    // }

    // this.router.navigate(["/403"], {
    //   queryParams: { returnUrl: this.router.url  },
    // });
    // return false;
  }

  checkMultipleAccess(permissions) {
    let permissionsArray = permissions.split(",");
    let permissionsFilter: any;

    let i = 1;
    for (const key in permissionsArray) {
      permissionsFilter = this.permissions.filter(function (p) {
        return p.name == permissionsArray[key]; // permission check using name
      });

      if (permissionsFilter.length > 0 && permissionsFilter[0].value != "")
        return true;

      if (i >= permissionsArray.length) {
        console.log("yes false");
        return false;
      }

      i++;
    }
  }

  checkAccess(permission) {
    let permissionsFilter: any;

    permissionsFilter = this.permissions.filter(function (p) {
      return p.name == permission; // permission check using name
    });

    if (permissionsFilter.length > 0 && permissionsFilter[0].value != "")
      return true;

    return false;
  }
}
